
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh-hant-hk",
  "es",
  "ja",
  "ko",
  "zh",
  "id",
  "it",
  "ar",
  "th",
  "de",
  "ru",
  "fr",
  "pt",
  "tr",
  "hi"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_55862b1c",
      load: () => import("#nuxt-i18n/55862b1c" /* webpackChunkName: "locale_en_46js_55862b1c" */),
      cache: false
    }
  ],
  "zh-hant-hk": [
    {
      key: "locale_zh_Hant_46js_ba25baa6",
      load: () => import("#nuxt-i18n/ba25baa6" /* webpackChunkName: "locale_zh_Hant_46js_ba25baa6" */),
      cache: false
    }
  ],
  es: [
    {
      key: "locale_es_46js_583bbcef",
      load: () => import("#nuxt-i18n/583bbcef" /* webpackChunkName: "locale_es_46js_583bbcef" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_jp_46js_003ae701",
      load: () => import("#nuxt-i18n/003ae701" /* webpackChunkName: "locale_jp_46js_003ae701" */),
      cache: false
    }
  ],
  ko: [
    {
      key: "locale_ko_46js_49e46140",
      load: () => import("#nuxt-i18n/49e46140" /* webpackChunkName: "locale_ko_46js_49e46140" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_46js_622b5337",
      load: () => import("#nuxt-i18n/622b5337" /* webpackChunkName: "locale_zh_46js_622b5337" */),
      cache: false
    }
  ],
  id: [
    {
      key: "locale_id_46js_6087346f",
      load: () => import("#nuxt-i18n/6087346f" /* webpackChunkName: "locale_id_46js_6087346f" */),
      cache: false
    }
  ],
  it: [
    {
      key: "locale_it_46js_71339bbd",
      load: () => import("#nuxt-i18n/71339bbd" /* webpackChunkName: "locale_it_46js_71339bbd" */),
      cache: false
    }
  ],
  ar: [
    {
      key: "locale_ar_46js_a562e6df",
      load: () => import("#nuxt-i18n/a562e6df" /* webpackChunkName: "locale_ar_46js_a562e6df" */),
      cache: false
    }
  ],
  th: [
    {
      key: "locale_th_46js_785de9d7",
      load: () => import("#nuxt-i18n/785de9d7" /* webpackChunkName: "locale_th_46js_785de9d7" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_de_46js_e7408b5f",
      load: () => import("#nuxt-i18n/e7408b5f" /* webpackChunkName: "locale_de_46js_e7408b5f" */),
      cache: false
    }
  ],
  ru: [
    {
      key: "locale_ru_46js_d32a1758",
      load: () => import("#nuxt-i18n/d32a1758" /* webpackChunkName: "locale_ru_46js_d32a1758" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_fr_46js_d8a0fa23",
      load: () => import("#nuxt-i18n/d8a0fa23" /* webpackChunkName: "locale_fr_46js_d8a0fa23" */),
      cache: false
    }
  ],
  pt: [
    {
      key: "locale_pt_46js_0d56cc5a",
      load: () => import("#nuxt-i18n/0d56cc5a" /* webpackChunkName: "locale_pt_46js_0d56cc5a" */),
      cache: false
    }
  ],
  tr: [
    {
      key: "locale_tr_46js_482fc8ee",
      load: () => import("#nuxt-i18n/482fc8ee" /* webpackChunkName: "locale_tr_46js_482fc8ee" */),
      cache: false
    }
  ],
  hi: [
    {
      key: "locale_hi_46js_8513765d",
      load: () => import("#nuxt-i18n/8513765d" /* webpackChunkName: "locale_hi_46js_8513765d" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/7520398e" /* webpackChunkName: "config_i18n_46config_46ts_7520398e" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      language: "en",
      _hreflang: "en",
      _sitemap: "en",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "zh-hant-hk",
      name: "繁体",
      language: "zh-Hant-Hk",
      _hreflang: "zh-Hant-Hk",
      _sitemap: "zh-Hant-Hk",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/zh_Hant.js",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      language: "es",
      _hreflang: "es",
      _sitemap: "es",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "日本語",
      language: "ja",
      _hreflang: "ja",
      _sitemap: "ja",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/jp.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "한국어",
      language: "ko",
      _hreflang: "ko",
      _sitemap: "ko",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ko.js",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      name: "中文",
      language: "zh",
      _hreflang: "zh",
      _sitemap: "zh",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/zh.js",
          cache: undefined
        }
      ]
    },
    {
      code: "id",
      name: "Indonesia",
      language: "id",
      _hreflang: "id",
      _sitemap: "id",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/id.js",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italiano",
      language: "it",
      _hreflang: "it",
      _sitemap: "it",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/it.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      name: "العربية",
      language: "ar",
      _hreflang: "ar",
      _sitemap: "ar",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ar.js",
          cache: undefined
        }
      ]
    },
    {
      code: "th",
      name: "ภาษาไทย",
      language: "th",
      _hreflang: "th",
      _sitemap: "th",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/th.js",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      language: "de",
      _hreflang: "de",
      _sitemap: "de",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Русский",
      language: "ru",
      _hreflang: "ru",
      _sitemap: "ru",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ru.js",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      language: "fr",
      _hreflang: "fr",
      _sitemap: "fr",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Português",
      language: "pt",
      _hreflang: "pt",
      _sitemap: "pt",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/pt.js",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Türkçe",
      language: "tr",
      _hreflang: "tr",
      _sitemap: "tr",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/tr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "hi",
      name: "हिन्दी",
      language: "hi",
      _hreflang: "hi",
      _sitemap: "hi",
      files: [
        {
          path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/hi.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en",
    _hreflang: "en",
    _sitemap: "en",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-hant-hk",
    name: "繁体",
    language: "zh-Hant-Hk",
    _hreflang: "zh-Hant-Hk",
    _sitemap: "zh-Hant-Hk",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/zh_Hant.js",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    language: "es",
    _hreflang: "es",
    _sitemap: "es",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "日本語",
    language: "ja",
    _hreflang: "ja",
    _sitemap: "ja",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/jp.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "한국어",
    language: "ko",
    _hreflang: "ko",
    _sitemap: "ko",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ko.js",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    name: "中文",
    language: "zh",
    _hreflang: "zh",
    _sitemap: "zh",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/zh.js",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    name: "Indonesia",
    language: "id",
    _hreflang: "id",
    _sitemap: "id",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/id.js",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    language: "it",
    _hreflang: "it",
    _sitemap: "it",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/it.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    name: "العربية",
    language: "ar",
    _hreflang: "ar",
    _sitemap: "ar",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ar.js",
        cache: undefined
      }
    ]
  },
  {
    code: "th",
    name: "ภาษาไทย",
    language: "th",
    _hreflang: "th",
    _sitemap: "th",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/th.js",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de",
    _hreflang: "de",
    _sitemap: "de",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Русский",
    language: "ru",
    _hreflang: "ru",
    _sitemap: "ru",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/ru.js",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    language: "fr",
    _hreflang: "fr",
    _sitemap: "fr",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Português",
    language: "pt",
    _hreflang: "pt",
    _sitemap: "pt",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/pt.js",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Türkçe",
    language: "tr",
    _hreflang: "tr",
    _sitemap: "tr",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/tr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    name: "हिन्दी",
    language: "hi",
    _hreflang: "hi",
    _sitemap: "hi",
    files: [
      {
        path: "/var/lib/jenkins/workspace/blink-nuxt-h5/i18n/locales/hi.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/